import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncOverlayContainer = Loadable({
  loader: () => import( /* webpackChunkName: "overlay-container" */'./OverlayContainer').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncOverlayContainer;